export default class Contact {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async createContact(contactObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/contact/new';
    req.body = { ...contactObj };
    return await req.exec();
  }
  async updateContact(contactObj, contactID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/contact/' + contactID;
    req.body = { ...contactObj };
    return await req.exec();
  }
  async deleteContact(contactID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/contact/' + contactID;
    return await req.exec();
  }
  async getContact(contactID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/contact/' + contactID;
    return await req.exec();
  }
  /* List */
  async getAllContacts() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/contacts';
    return await req.exec();
  }
  /* Search */
  async searchContactsByTerm(searchTerm, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/contacts/search';
    req.body = { searchTerm, filter: filters };
    return await req.exec();
  }
  async searchContactsAutocomplete(value) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/contacts/search/autocomplete';
    req.body = { value };
    return await req.exec();
  }
  async exportContactsSearch(searchTerm, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/contacts/search/export';
    req.bodyType = 'JSON/BLOB';
    req.body = { searchTerm, filter: filters };
    return await req.exec();
  }
  async searchContactsByIDs(filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/contacts/search/byIDs';
    req.body = { filter: filters };
    return await req.exec();
  }
}
